import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router, Route } from '@angular/router';
import {
  ProductFlowService,
  ProductFlowConfig,
} from 'app/infrastructure/services/productFlow.service';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { SxDocumentTypes } from '../sxfdesigner/components/main/completeContext';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';

@Component({
  selector: 'sx-product-flow-list',
  templateUrl: './productFlowList.component.html',
})
export class ProductFlowListComponent {
  public searchPage: string;
  public searchInteractionRule: string;

  codSistema: string;
  codNegocio: string;
  codProduct: string;
  documentKind: string;
  standardKey: string = null;
  preguntarSiDeseaBorrar = [];
  standardFlow: boolean;
  flowConfig: ProductFlowConfig[] = [];
  showCategories: boolean = false;

  constructor(
    private productFlowService: ProductFlowService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private translate: Translator,
    private modalService: NgbModal
  ) {
    this.aRoute.data.subscribe((dd: Params) => {
      this.standardFlow = dd.standardFlow !== undefined ? dd.standardFlow : false;
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProduct = params['codproducto'];
      this.documentKind = params['documentKind'];
  
      if (this.codSistema == null) {
        this.codSistema = 'null';
        this.showCategories = true;
      }
      if (this.codNegocio == null) {
        this.codNegocio = 'null';
      }
      if (this.codProduct == null) {
        this.codProduct = 'null';
      }
      if (this.documentKind == null) {
        this.documentKind = SxDocumentTypes.None;
      }
      if (this.standardFlow) {
        if (this.hasChannelContext()) {
          this.standardKey = null;
          this.productFlowService
            .getStandardProductFlows(
              this.codSistema,
              this.codNegocio,
              this.codProduct,
              this.documentKind,
              this.standardKey
            )
            .then((x) => {
              this.flowConfig = x;
              console.log(this.flowConfig)
            });
        } else {
          this.standardKey = null;
          this.productFlowService
            .getStandardFlows(this.documentKind, this.standardKey)
            .subscribe((x) => (this.flowConfig = x));
        }
      } else {
        this.productFlowService
          .getProductFlows(
            this.codSistema,
            this.codNegocio,
            this.codProduct,
            this.documentKind
          )
          .subscribe((x) => (this.flowConfig = x));
      }});
    });
  }

  // --------------------------------------------------------------------
  // flows
  clickEditFlow(flowCode: string) {
    this.router.navigate(['.', flowCode], { relativeTo: this.aRoute });
  }

  clickDeleteFlow(codFlow: string, hasReferences: boolean) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);

    const modalInstance = <ConfirmacionModalComponent>(
      modalRef.componentInstance
    );
    const text = <string>this.translate.instant('DISABLE_TEXT');
    const flowReferences = <string>(
      this.translate.instant('DISABLE_STANDARD_FLOW_REFERENCES')
    );
    hasReferences && this.codSistema == 'null'
      ? (modalInstance.titulo = `${text} ${codFlow}${flowReferences}?`)
      : (modalInstance.titulo = `${text} ${codFlow}?`);
    modalRef.result.then(() => {
      if (this.standardFlow === true) {
        this.standardKey = 'standardDictionary';
        this.productFlowService
          .DeleteOrUnsuscribeStandardFlow(
            this.codSistema,
            this.codNegocio,
            this.codProduct,
            this.documentKind,
            this.standardKey,
            codFlow
          )
          .then((success) => {
            if (success) {
              this.alertService.showGrowl(
                {
                  type: GrowlType.SUCCESS,
                  body: 'SUCCESSFUL_DELETE_OF_FLOW_WITH_CODFLOW',
                },
                { codFlow: codFlow }
              );
            } else {
              this.alertService.showGrowl(
                {
                  type: GrowlType.DANGER,
                  body: 'SOC_FE_0010_COULD_NOT_DELETE_FLOW_WITH_CODE',
                },
                { codFlow: codFlow }
              );
            }
            this.flowConfig = this.flowConfig.filter(
              (f) => f.flowCode !== codFlow
            );
          });
      } else {
        this.productFlowService
          .DeleteFlow(
            this.codSistema,
            this.codNegocio,
            this.codProduct,
            codFlow,
            this.documentKind
          )
          .then((success) => {
            if (success) {
              this.alertService.showGrowl(
                {
                  type: GrowlType.SUCCESS,
                  body: 'SUCCESSFUL_DELETE_OF_FLOW_WITH_CODFLOW',
                },
                { codFlow: codFlow }
              );
            } else {
              this.alertService.showGrowl(
                {
                  type: GrowlType.DANGER,
                  body: 'SOC_FE_0010_COULD_NOT_DELETE_FLOW_WITH_CODE',
                },
                { codFlow: codFlow }
              );
            }
            this.flowConfig = this.flowConfig.filter(
              (f) => f.flowCode !== codFlow
            );
          });
      }
    });
  }

  showCreateFlow() {
    return !(this.standardFlow && this.hasProductContext());
  }

  showImportFlow() {
    return (
      this.isPolicy() && this.hasSusbscriptionContext() && !this.standardFlow
    );
  }

  showNewSusbscription() {
    return this.standardFlow && this.hasProductContext();
  }

  isPolicy() {
    return this.documentKind === 'Policy';
  }

  hasSusbscriptionContext() {
    return this.codSistema !== 'null';
  }

  hasChannelContext() {
    return this.codNegocio !== 'null';
  }

  hasProductContext() {
    return this.codProduct !== 'null';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/productFlowList.component.ts